import Vue from 'vue'

export async function getClientes(context, [access_token, params, con_loading]) {
    
    try {
        if (access_token) {
            if (con_loading){
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/clientes',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                params: params
            })
           
            context.commit('clientes/setClientes', response.data.data, { root: true })
            return response;
        }

    } catch (e) {
    } finally {
        if (con_loading){
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function crearCliente(context, [access_token, modelCliente]) {
    try {

        if (access_token) {
           // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/clientes',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelCliente
            })
         
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateCliente(context, [access_token, modelCliente]) {
    try {
        if (access_token) {
          
            const response = await Vue.axios({
                method: 'PUT',
                url: '/clientes/' + modelCliente.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelCliente
            })
            if (response.status == 200) {
                context.commit('clientes/actListClientes', response.data.data, { root: true })
               }
           return response;
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
     // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarCliente(context, [access_token, cliente_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/clientes/' + cliente_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })

          
           if (response.status == 200) {
            context.commit('clientes/actDeleteListClientes', cliente_id, { root: true })
           }
           return response;
          
           // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
      // context.commit('setLoading', false, { root: true })
    }
}


